import Alert from '../../components/Alert';

const AlertComponent = ({ text }) => {
  return (
    <div className={`container-lg p-2 p-lg-4 p-xl-4`}>
      <Alert type={'danger'}>{text}</Alert>
    </div>
  );
};

export default AlertComponent;
